import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { InputFromUser } from '../../../components/Input/input';
import Header from '../../../components/Header';
import { RadioButton, SingleMultiSelectDropDown } from '../../../components/Input/InputText';
import React, { useEffect, useState } from 'react';
import { Divider } from 'antd';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllsolution } from '../../../store/Actions/ServiceAction';
import { SolutionSlotValidationSchema } from '../../../utils/FormValidation';
import { ActionCreateByUrl } from '../../../store/Actions/CommonAction';

const initialFormValues = {
  date: '',
  startTime: '',
  phoneNo: '',
  email: '',
  customerName: '',
  gender: '',
  solutionName: [],
};

const Add_SolutionSlot = () => {
  const [formValues, setFormValues] = useState([initialFormValues]);
  const [selectedSolutions, setSelectedSolutions] = useState([[]]);
  // const [solutionLists, setSolutionLists] = useState([]);
  const handleSolutionSelection = (guestIndex, selected) => {
    const updatedSelectedSolution = [...selectedSolutions];
    updatedSelectedSolution[guestIndex] = selected;
    setSelectedSolutions(updatedSelectedSolution);
  };

  const addGuestForm = () => {
    setFormValues([...formValues, initialFormValues]);
    setSelectedSolutions([...selectedSolutions, []]);
  };

  const removeGuestForm = indexToRemove => {
    const updatedForms = formValues.filter((_, index) => index !== indexToRemove);
    setFormValues(updatedForms);

    const updatedSelectedSolution = selectedSolutions.filter((_, index) => index !== indexToRemove);
    setSelectedSolutions(updatedSelectedSolution);
  };

  const calculateTotalPrice = () => {
    let total = 0;

    formValues.forEach((guestValues, index) => {
      let totalPricePerGuest = 0;

      selectedSolutions[index]?.forEach(selectedSolution => {
        solutionList.forEach(solutionItem => {
          const foundSolution = solutionItem.docs.find(item => item.name === selectedSolution);
          if (foundSolution) {
            const price = foundSolution.price;
            totalPricePerGuest += Number(price[0]);
          }
        });
      });

      total += totalPricePerGuest;
    });

    return total;
  };

  const { solutionList } = useSelector(state => state?.Service);

  const dispatch = useDispatch();
  const params = queryString.parse(location.search);

  useEffect(() => {
    dispatch(GetAllsolution({ Query: `?page=${params?.page || 1}` }));
  }, []);

  useEffect(() => {
    if (solutionList && solutionList.length > 0) {
      // const lists = solutionList.map(solution => solution.docs);
      // setSolutionLists(lists);
    }
  }, [solutionList]);

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/solution-slot">Solution Booking</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Add Solution Slot Booking</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-8">
                  <div className="card p-3">
                    <div className="card-body">
                      {formValues.map((values, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && (
                            <Divider style={{ fontWeight: '600' }}>Other Guest Details</Divider>
                          )}
                          <Formik
                            initialValues={values}
                            validationSchema={SolutionSlotValidationSchema}
                            onSubmit={(values, { setSubmitting, setErrors }) => {
                              dispatch(
                                ActionCreateByUrl(
                                  {
                                    Query: 'admin/solution-slot',
                                    obj: {
                                      customerName: values.customerName,
                                      solutionName: values.solutionName,
                                      date: values.date,
                                      startTime: values.startTime,
                                      phoneNo: values.phoneNo,
                                      email: values.email,
                                      gender: values.gender,
                                    },
                                  },
                                  Res => {
                                    setSubmitting(false);
                                    if (Res?.statusCode === 200 || Res?.status === 200) {
                                      window.location.href = `/solution-slot`;
                                    } else {
                                      setErrors(Res?.data?.errors || Res?.errors || {});
                                    }
                                  }
                                )
                              );
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              setFieldValue,
                              isSubmitting,
                            }) => {
                              return (
                                <div>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-heading">
                                        <h4>Add Solution Slots Manually</h4>
                                      </div>
                                    </div>

                                    <InputFromUser
                                      label="Date"
                                      type="date"
                                      name="date"
                                      onChange={v => {
                                        setFieldValue('date', v, true);
                                        const updatedForms = [...formValues];
                                        updatedForms[index].date = v;
                                        setFormValues(updatedForms);
                                      }}
                                      onBlur={handleBlur}
                                      FormControlClassName={'form-control'}
                                      FormGroupClassName={'col-xl-6 col-md-12 '}
                                      LabelClassName={'col-form-label'}
                                      value={values?.date}
                                      error={errors.date}
                                      touched={touched.date}
                                      placeholder={'Enter date'}
                                    />

                                    <InputFromUser
                                      placeholder={'Arrival Time'}
                                      type="text"
                                      name="startTime"
                                      onChange={v => {
                                        handleChange(v);
                                        const updatedForms = [...formValues];
                                        updatedForms[index].startTime = v.target.value;
                                        setFormValues(updatedForms);
                                      }}
                                      FormGroupClassName={'col-xl-6 col-md-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values?.startTime}
                                      label="Arrival Time"
                                      error={errors?.startTime}
                                      touched={touched.startTime}
                                    />

                                    <InputFromUser
                                      placeholder={'Phone No.'}
                                      type="text"
                                      name="phoneNo"
                                      onChange={v => {
                                        handleChange(v);
                                        const updatedForms = [...formValues];
                                        updatedForms[index].phoneNo = v.target.value;
                                        setFormValues(updatedForms);
                                      }}
                                      FormGroupClassName={'col-xl-6 col-md-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values?.phoneNo}
                                      label="Phone No."
                                      error={errors?.phoneNo}
                                      touched={touched.phoneNo}
                                    />

                                    <InputFromUser
                                      placeholder={'Email'}
                                      type="email"
                                      name="email"
                                      onChange={v => {
                                        handleChange(v);
                                        const updatedForms = [...formValues];
                                        updatedForms[index].email = v.target.value;
                                        setFormValues(updatedForms);
                                      }}
                                      FormGroupClassName={'col-xl-6 col-md-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values?.email}
                                      label="Email"
                                      error={errors?.email}
                                      touched={touched.email}
                                    />

                                    <InputFromUser
                                      placeholder={'Customer Name'}
                                      type="text"
                                      name="customerName"
                                      onChange={v => {
                                        handleChange(v);
                                        const updatedForms = [...formValues];
                                        updatedForms[index].customerName = v.target.value;
                                        setFormValues(updatedForms);
                                      }}
                                      FormGroupClassName={'col-xl-6 col-md-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values?.customerName}
                                      label="Customer Name"
                                      error={errors?.customerName}
                                      touched={touched.customerName}
                                    />

                                    <RadioButton
                                      label={'Gender'}
                                      options={[
                                        { label: 'Male', value: 'Male' },
                                        { label: 'Female', value: 'Female' },
                                        { label: 'Others', value: 'Others' },
                                      ]}
                                      onBlur={() =>
                                        handleBlur({
                                          target: {
                                            name: 'gender',
                                            value: true,
                                          },
                                        })
                                      }
                                      onChange={v => {
                                        handleChange({
                                          target: {
                                            name: 'gender',
                                            value: v,
                                          },
                                        });
                                        const updatedForms = [...formValues];
                                        updatedForms[index].gender = v;
                                        setFormValues(updatedForms);
                                      }}
                                      error={errors.gender}
                                      selectedValue={values?.gender}
                                      touched={touched.gender}
                                    />

                                    <SingleMultiSelectDropDown
                                      label="Solutions"
                                      type="solutionName"
                                      Showlabel={true}
                                      mode={'multiple'}
                                      name="solutionName"
                                      onChange={v => {
                                        setFieldValue('solutionName', v, true);
                                        handleSolutionSelection(index, v);
                                      }}
                                      FormControlClassName={'form-control'}
                                      FormGroupClassName={'col-xl-6 col-md-12'}
                                      LabelClassName={'col-form-label'}
                                      value={values?.solutionName}
                                      error={errors?.solutionName}
                                      touched={touched?.solutionName}
                                      loading={false}
                                      options={
                                        solutionList &&
                                          solutionList.length > 0 &&
                                          solutionList[0]?.docs
                                          ? solutionList[0]?.docs?.map(item => item?.name)
                                          : []
                                      }
                                      placeholder={'Enter Solutions'}
                                    />

                                    <div className="col-12 mt-4">
                                      <div className="doctor-submit text-end mt-3">
                                        {index === 0 ? (
                                          <button
                                            type="button"
                                            onClick={addGuestForm}
                                            className="btn btn-primary submit-form me-2"
                                          >
                                            Add More Guest
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={() => removeGuestForm(index)}
                                            className="btn btn-danger submit-form me-2"
                                          >
                                            Remove Guest
                                          </button>
                                        )}
                                        <button
                                          type="submit"
                                          className="btn btn-primary submit-form"
                                          disabled={isSubmitting}
                                          onClick={() => handleSubmit()}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }}
                          </Formik>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="card p-3">
                    <div className="card-body">
                      <h2 className="mb-3">Total Summary</h2>
                      <Divider />
                      {formValues.map((guest, index) => (
                        <React.Fragment key={index}>
                          <div key={index}>
                            <h3>
                              Guest {index + 1}: {guest.customerName || 'N/A'}
                            </h3>
                            <p className="mb-1">
                              {guest.phoneNo} | {guest.email}
                            </p>
                            <div className="d-flex justify-content-between py-3">
                              <div>
                                <h4>Selected Solutions</h4>
                              </div>
                              <div>
                                <h4>Price</h4>
                              </div>
                            </div>
                            {selectedSolutions[index]?.map((selectedSolution, solutionIndex) => {
                              let price = 'Price not available';

                              solutionList?.forEach(solutionItem => {
                                const foundSolution = solutionItem.docs.find(
                                  item => item.name === selectedSolution
                                );
                                if (foundSolution) {
                                  price = foundSolution.price;
                                }
                              });

                              return (
                                <div key={solutionIndex} className="d-flex justify-content-between">
                                  <div>
                                    <p>{selectedSolution}</p>
                                  </div>
                                  <div>
                                    <p>{price}</p>
                                  </div>
                                </div>
                              );
                            })}

                            <Divider />
                          </div>
                        </React.Fragment>
                      ))}
                      <div className="d-flex justify-content-between py-3">
                        <div>
                          <h3>Total Price: </h3>
                        </div>
                        <div>
                          <h3>₹{calculateTotalPrice()}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Add_SolutionSlot;
